import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { KhudaKiAwazDataProvider } from '../../providers/khuda-ki-awaz-data/khuda-ki-awaz-data';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

import {DetailsPage} from '../details/details';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  items: any;

  constructor(public navCtrl: NavController, public khudaKiAwazService: KhudaKiAwazDataProvider, public http: HttpClient) {

    let data: Observable<any>;
    //data = this.http.get("http://kalamekhuda.com/khudakiawaz.json");
    data = this.http.get('assets/khudakiawaz.json');
    data.subscribe(result => {

      this.items = result;
    })
  }
    
  openDetailsPage(item){
    
    this.navCtrl.push(DetailsPage, { 
      //itemTitle = "This is test item Title"
      
      /*itemContent: item.post_content,
      
      itemTitle: item.post_title,

      itemLink: item.post_link
      */
     itemTitle: item.title,
     itemContent: item.description,
     itemLink: item.guid,
     itemDuration: item.duration.__text,
     itemHost: item.author.__cdata,
     itemSize: item.enclosure._length


      //itemTitle: this.onlineDataService.onlineData[index.toString()].post_title,
      //itemContent: this.onlineDataService.onlineData[index.toString()].post_content
    });
    //console.log("ID #: ", this.onlineDataService.onlineData [index.toString()].id);
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts